import { useFormikContext } from 'formik'

import { useBeforeUnload, useBlockNavigation } from '../../../../../hooks'
import { CHATROOM_INPUT_FIELD_NAME_MESSAGE } from '../../../Chatroom.constants'
import { isChatroomMessageEditChanged } from '../../ChatroomMessageEditForm.utils'

export function useChatroomMessageEditUnsavedChanges({ files, initialFiles }) {
  const { initialValues, values } = useFormikContext()

  const isChanged = isChatroomMessageEditChanged({
    files,
    initialFiles,
    initialText: initialValues[CHATROOM_INPUT_FIELD_NAME_MESSAGE],
    text: values[CHATROOM_INPUT_FIELD_NAME_MESSAGE],
  })

  useBeforeUnload(isChanged, true)
  useBlockNavigation(isChanged)

  return isChanged
}
